import { render, staticRenderFns } from "./DynamicFieldEditor.vue?vue&type=template&id=b06c70b0&scoped=true&"
import script from "./DynamicFieldEditor.vue?vue&type=script&lang=js&"
export * from "./DynamicFieldEditor.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFieldEditor.vue?vue&type=style&index=0&id=b06c70b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06c70b0",
  null
  
)

export default component.exports